export default {
  error: 'Erreur',
  sorry: "Désolé, nous avons reçu l'erreur suivante",
  workingOnIt:
    'Un ingénieur a été informé de ce problème et nous travaillons à le résoudre aussi rapidement que possible.',
  tryAgain: 'Merci de réessayer plus tard',
  noInternet:
    "Il semble y avoir un problème avec ta connexion Internet. S'il te plaît, vérifie et essaye à nouveau.",
}
